import { render, staticRenderFns } from "./Clgc.vue?vue&type=template&id=0cca47fe&scoped=true&"
import script from "./Clgc.vue?vue&type=script&lang=js&"
export * from "./Clgc.vue?vue&type=script&lang=js&"
import style0 from "./Clgc.vue?vue&type=style&index=0&id=0cca47fe&lang=less&scoped=true&"
import style1 from "./Clgc.vue?vue&type=style&index=1&id=0cca47fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca47fe",
  null
  
)

export default component.exports